import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/pages/HomeIndex'
import mine from '@/pages/mine/mine'
import verifyMesg from '@/pages/verify/verifyMesg'
import verifyMesgcopy from '@/pages/verify/verifyMesgcopy'
import verifyOrder from '@/pages/verify/verifyOrder'
import verifyOrderDetail from '@/pages/verify/verifyOrderDetail'
import storeMesg from '@/pages/store/storeMesg'
import staffList from '@/pages/store/staffList'
import addStaff from '@/pages/store/addStaff'
import adminNum from '@/pages/mine/adminNum'
import login from '@/pages/login/login'
import signIn from '@/pages/login/signIn'
// 导入结算相关路由
import settlementRoutes from './settlement'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex
    },
    {
      path: '/mine',
      name: 'mine',
      component: mine
    },
    {
      path: '/verifyMesg',
      name: 'verifyMesg',
      component: verifyMesg
    },
    {
      path: '/verifyMesgcopy',
      name: 'verifyMesgcopy',
      component: verifyMesgcopy
    },
    {
      path: '/verifyOrder',
      name: 'verifyOrder',
      component: verifyOrder
    },
    {
      path: '/verifyOrderDetail',
      name: 'verifyOrderDetail',
      component: verifyOrderDetail
    },
    {
      path: '/storeMesg',
      name: 'storeMesg',
      component: storeMesg
    },
    {
      path: '/staffList',
      name: 'staffList',
      component: staffList
    },
    {
      path: '/addStaff',
      name: 'addStaff',
      component: addStaff
    },
    {
      path: '/adminNum',
      name: 'adminNum',
      component: adminNum
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/signIn',
      name: 'signIn',
      component: signIn
    },
    // 结算相关路由
    ...settlementRoutes
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js